/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EloshieldClassicStationaryModule
 */
export interface EloshieldClassicStationaryModule {
    /**
     * 
     * @type {string}
     * @memberof EloshieldClassicStationaryModule
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof EloshieldClassicStationaryModule
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof EloshieldClassicStationaryModule
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof EloshieldClassicStationaryModule
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof EloshieldClassicStationaryModule
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof EloshieldClassicStationaryModule
     */
    machineId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof EloshieldClassicStationaryModule
     */
    antennaANetworkIds: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof EloshieldClassicStationaryModule
     */
    antennaBNetworkIds: Array<number>;
}

/**
 * Check if a given object implements the EloshieldClassicStationaryModule interface.
 */
export function instanceOfEloshieldClassicStationaryModule(value: object): value is EloshieldClassicStationaryModule {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('machineId' in value) || value['machineId'] === undefined) return false;
    if (!('antennaANetworkIds' in value) || value['antennaANetworkIds'] === undefined) return false;
    if (!('antennaBNetworkIds' in value) || value['antennaBNetworkIds'] === undefined) return false;
    return true;
}

export function EloshieldClassicStationaryModuleFromJSON(json: any): EloshieldClassicStationaryModule {
    return EloshieldClassicStationaryModuleFromJSONTyped(json, false);
}

export function EloshieldClassicStationaryModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): EloshieldClassicStationaryModule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'serialNumber': json['serialNumber'],
        'label': json['label'],
        'machineId': json['machineId'],
        'antennaANetworkIds': json['antennaANetworkIds'],
        'antennaBNetworkIds': json['antennaBNetworkIds'],
    };
}

export function EloshieldClassicStationaryModuleToJSON(json: any): EloshieldClassicStationaryModule {
    return EloshieldClassicStationaryModuleToJSONTyped(json, false);
}

export function EloshieldClassicStationaryModuleToJSONTyped(value?: EloshieldClassicStationaryModule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'serialNumber': value['serialNumber'],
        'label': value['label'],
        'machineId': value['machineId'],
        'antennaANetworkIds': value['antennaANetworkIds'],
        'antennaBNetworkIds': value['antennaBNetworkIds'],
    };
}

